// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1LNPU","choiceBoxes":"toolbarselects_choiceBoxes__ahllG","simpleField":"toolbarselects_simpleField__3mwHy"};